<div class="wrapper">
  <div class="result-title">{{ '+SERVICE_TICKET.CALL_RESULT_TITLE' | translate }}</div>
  <span *ngrxLet="serviceTicketStore.arrangedCallbackDetails$ | async as cb">
    <ng-container *ngIf="authStore.getName() | async as userName">
      <ng-container [ngSwitch]="areWorkingHours(cb.time)">
        <div
          class="result-description"
          *ngSwitchCase="'yes'"
          [innerHTML]="
            '+SERVICE_APP.BAR.MESSAGE'
              | translate: { requester: userName, device: cb.device, id: cb.id }
              | trustHtml
          "
        ></div>
        <div
          class="result-description"
          *ngSwitchCase="'before'"
          [innerHTML]="
            '+SERVICE_APP.BAR.MESSAGE_BEFORE_WORKING_HOURS'
              | translate: { requester: userName, device: cb.device, id: cb.id }
              | trustHtml
          "
        ></div>
        <div
          class="result-description"
          *ngSwitchCase="'after'"
          [innerHTML]="
            '+SERVICE_APP.BAR.MESSAGE_AFTER_WORKING_HOURS'
              | translate: { requester: userName, device: cb.device, id: cb.id }
              | trustHtml
          "
        ></div>
      </ng-container>
    </ng-container>
  </span>
</div>
